export const PROFILE_VIEW_REVAMP = "profile_view_revamp"
export const PROFILE_EDITION_REVAMP = "profile_revamp_edition"
